/* eslint-disable */

// @ts-nocheck

// This file was automatically generated by @icp-sdk/bindgen@0.3.0.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import {IDL} from '@icp-sdk/core/candid';

export const GetBlocksResult = IDL.Rec();
export const Value = IDL.Rec();
export const ChangeIndexId = IDL.Variant({
  SetTo: IDL.Principal,
  Unset: IDL.Null
});
export const UpgradeArgs = IDL.Record({
  change_index_id: IDL.Opt(ChangeIndexId),
  max_blocks_per_request: IDL.Opt(IDL.Nat64)
});
export const Account = IDL.Record({
  owner: IDL.Principal,
  subaccount: IDL.Opt(IDL.Vec(IDL.Nat8))
});
export const InitArgs = IDL.Record({
  initial_balances: IDL.Opt(IDL.Vec(IDL.Tuple(Account, IDL.Nat))),
  index_id: IDL.Opt(IDL.Principal),
  max_blocks_per_request: IDL.Nat64
});
export const LedgerArgs = IDL.Variant({
  Upgrade: IDL.Opt(UpgradeArgs),
  Init: InitArgs
});
export const SubnetFilter = IDL.Record({subnet_type: IDL.Opt(IDL.Text)});
export const SubnetSelection = IDL.Variant({
  Filter: SubnetFilter,
  Subnet: IDL.Record({subnet: IDL.Principal})
});
export const CanisterSettings = IDL.Record({
  freezing_threshold: IDL.Opt(IDL.Nat),
  controllers: IDL.Opt(IDL.Vec(IDL.Principal)),
  reserved_cycles_limit: IDL.Opt(IDL.Nat),
  memory_allocation: IDL.Opt(IDL.Nat),
  compute_allocation: IDL.Opt(IDL.Nat)
});
export const CmcCreateCanisterArgs = IDL.Record({
  subnet_selection: IDL.Opt(SubnetSelection),
  settings: IDL.Opt(CanisterSettings)
});
export const CreateCanisterArgs = IDL.Record({
  from_subaccount: IDL.Opt(IDL.Vec(IDL.Nat8)),
  created_at_time: IDL.Opt(IDL.Nat64),
  amount: IDL.Nat,
  creation_args: IDL.Opt(CmcCreateCanisterArgs)
});
export const BlockIndex = IDL.Nat;
export const CreateCanisterSuccess = IDL.Record({
  block_id: BlockIndex,
  canister_id: IDL.Principal
});
export const CreateCanisterError = IDL.Variant({
  GenericError: IDL.Record({message: IDL.Text, error_code: IDL.Nat}),
  TemporarilyUnavailable: IDL.Null,
  Duplicate: IDL.Record({
    duplicate_of: IDL.Nat,
    canister_id: IDL.Opt(IDL.Principal)
  }),
  CreatedInFuture: IDL.Record({ledger_time: IDL.Nat64}),
  FailedToCreate: IDL.Record({
    error: IDL.Text,
    refund_block: IDL.Opt(BlockIndex),
    fee_block: IDL.Opt(BlockIndex)
  }),
  TooOld: IDL.Null,
  InsufficientFunds: IDL.Record({balance: IDL.Nat})
});
export const CreateCanisterFromArgs = IDL.Record({
  spender_subaccount: IDL.Opt(IDL.Vec(IDL.Nat8)),
  from: Account,
  created_at_time: IDL.Opt(IDL.Nat64),
  amount: IDL.Nat,
  creation_args: IDL.Opt(CmcCreateCanisterArgs)
});
export const RejectionCode = IDL.Variant({
  NoError: IDL.Null,
  CanisterError: IDL.Null,
  SysTransient: IDL.Null,
  DestinationInvalid: IDL.Null,
  Unknown: IDL.Null,
  SysFatal: IDL.Null,
  CanisterReject: IDL.Null
});
export const CreateCanisterFromError = IDL.Variant({
  FailedToCreateFrom: IDL.Record({
    create_from_block: IDL.Opt(BlockIndex),
    rejection_code: RejectionCode,
    refund_block: IDL.Opt(BlockIndex),
    approval_refund_block: IDL.Opt(BlockIndex),
    rejection_reason: IDL.Text
  }),
  GenericError: IDL.Record({message: IDL.Text, error_code: IDL.Nat}),
  TemporarilyUnavailable: IDL.Null,
  InsufficientAllowance: IDL.Record({allowance: IDL.Nat}),
  Duplicate: IDL.Record({
    duplicate_of: IDL.Nat,
    canister_id: IDL.Opt(IDL.Principal)
  }),
  CreatedInFuture: IDL.Record({ledger_time: IDL.Nat64}),
  TooOld: IDL.Null,
  InsufficientFunds: IDL.Record({balance: IDL.Nat})
});
export const DepositArgs = IDL.Record({
  to: Account,
  memo: IDL.Opt(IDL.Vec(IDL.Nat8))
});
export const DepositResult = IDL.Record({
  balance: IDL.Nat,
  block_index: BlockIndex
});
export const HttpRequest = IDL.Record({
  url: IDL.Text,
  method: IDL.Text,
  body: IDL.Vec(IDL.Nat8),
  headers: IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text))
});
export const HttpResponse = IDL.Record({
  body: IDL.Vec(IDL.Nat8),
  headers: IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
  status_code: IDL.Nat16
});
export const GetAllowancesArgs = IDL.Record({
  take: IDL.Opt(IDL.Nat),
  prev_spender: IDL.Opt(Account),
  from_account: IDL.Opt(Account)
});
export const Allowances = IDL.Vec(
  IDL.Record({
    from_account: Account,
    to_spender: Account,
    allowance: IDL.Nat,
    expires_at: IDL.Opt(IDL.Nat64)
  })
);
export const GetAllowancesError = IDL.Variant({
  GenericError: IDL.Record({message: IDL.Text, error_code: IDL.Nat}),
  AccessDenied: IDL.Record({reason: IDL.Text})
});
export const ICRC103GetAllowancesResponse = IDL.Variant({
  Ok: Allowances,
  Err: GetAllowancesError
});
export const GetIndexPrincipalError = IDL.Variant({
  GenericError: IDL.Record({
    description: IDL.Text,
    error_code: IDL.Nat
  }),
  IndexPrincipalNotSet: IDL.Null
});
export const GetIndexPrincipalResult = IDL.Variant({
  Ok: IDL.Principal,
  Err: GetIndexPrincipalError
});
export const MetadataValue = IDL.Variant({
  Int: IDL.Int,
  Nat: IDL.Nat,
  Blob: IDL.Vec(IDL.Nat8),
  Text: IDL.Text
});
export const SupportedStandard = IDL.Record({
  url: IDL.Text,
  name: IDL.Text
});
export const TransferArgs = IDL.Record({
  to: Account,
  fee: IDL.Opt(IDL.Nat),
  memo: IDL.Opt(IDL.Vec(IDL.Nat8)),
  from_subaccount: IDL.Opt(IDL.Vec(IDL.Nat8)),
  created_at_time: IDL.Opt(IDL.Nat64),
  amount: IDL.Nat
});
export const TransferError = IDL.Variant({
  GenericError: IDL.Record({message: IDL.Text, error_code: IDL.Nat}),
  TemporarilyUnavailable: IDL.Null,
  BadBurn: IDL.Record({min_burn_amount: IDL.Nat}),
  Duplicate: IDL.Record({duplicate_of: IDL.Nat}),
  BadFee: IDL.Record({expected_fee: IDL.Nat}),
  CreatedInFuture: IDL.Record({ledger_time: IDL.Nat64}),
  TooOld: IDL.Null,
  InsufficientFunds: IDL.Record({balance: IDL.Nat})
});
export const AllowanceArgs = IDL.Record({
  account: Account,
  spender: Account
});
export const Allowance = IDL.Record({
  allowance: IDL.Nat,
  expires_at: IDL.Opt(IDL.Nat64)
});
export const ApproveArgs = IDL.Record({
  fee: IDL.Opt(IDL.Nat),
  memo: IDL.Opt(IDL.Vec(IDL.Nat8)),
  from_subaccount: IDL.Opt(IDL.Vec(IDL.Nat8)),
  created_at_time: IDL.Opt(IDL.Nat64),
  amount: IDL.Nat,
  expected_allowance: IDL.Opt(IDL.Nat),
  expires_at: IDL.Opt(IDL.Nat64),
  spender: Account
});
export const ApproveError = IDL.Variant({
  GenericError: IDL.Record({message: IDL.Text, error_code: IDL.Nat}),
  TemporarilyUnavailable: IDL.Null,
  Duplicate: IDL.Record({duplicate_of: IDL.Nat}),
  BadFee: IDL.Record({expected_fee: IDL.Nat}),
  AllowanceChanged: IDL.Record({current_allowance: IDL.Nat}),
  CreatedInFuture: IDL.Record({ledger_time: IDL.Nat64}),
  TooOld: IDL.Null,
  Expired: IDL.Record({ledger_time: IDL.Nat64}),
  InsufficientFunds: IDL.Record({balance: IDL.Nat})
});
export const TransferFromArgs = IDL.Record({
  to: Account,
  fee: IDL.Opt(IDL.Nat),
  spender_subaccount: IDL.Opt(IDL.Vec(IDL.Nat8)),
  from: Account,
  memo: IDL.Opt(IDL.Vec(IDL.Nat8)),
  created_at_time: IDL.Opt(IDL.Nat64),
  amount: IDL.Nat
});
export const TransferFromError = IDL.Variant({
  GenericError: IDL.Record({message: IDL.Text, error_code: IDL.Nat}),
  TemporarilyUnavailable: IDL.Null,
  InsufficientAllowance: IDL.Record({allowance: IDL.Nat}),
  BadBurn: IDL.Record({min_burn_amount: IDL.Nat}),
  Duplicate: IDL.Record({duplicate_of: IDL.Nat}),
  BadFee: IDL.Record({expected_fee: IDL.Nat}),
  CreatedInFuture: IDL.Record({ledger_time: IDL.Nat64}),
  TooOld: IDL.Null,
  InsufficientFunds: IDL.Record({balance: IDL.Nat})
});
export const GetArchivesArgs = IDL.Record({from: IDL.Opt(IDL.Principal)});
export const GetArchivesResult = IDL.Vec(
  IDL.Record({
    end: IDL.Nat,
    canister_id: IDL.Principal,
    start: IDL.Nat
  })
);
export const GetBlocksArgs = IDL.Vec(IDL.Record({start: IDL.Nat, length: IDL.Nat}));
Value.fill(
  IDL.Variant({
    Int: IDL.Int,
    Map: IDL.Vec(IDL.Tuple(IDL.Text, Value)),
    Nat: IDL.Nat,
    Nat64: IDL.Nat64,
    Blob: IDL.Vec(IDL.Nat8),
    Text: IDL.Text,
    Array: IDL.Vec(Value)
  })
);
GetBlocksResult.fill(
  IDL.Record({
    log_length: IDL.Nat,
    blocks: IDL.Vec(IDL.Record({id: IDL.Nat, block: Value})),
    archived_blocks: IDL.Vec(
      IDL.Record({
        args: GetBlocksArgs,
        callback: IDL.Func([GetBlocksArgs], [GetBlocksResult], ['query'])
      })
    )
  })
);
export const DataCertificate = IDL.Record({
  certificate: IDL.Vec(IDL.Nat8),
  hash_tree: IDL.Vec(IDL.Nat8)
});
export const SupportedBlockType = IDL.Record({
  url: IDL.Text,
  block_type: IDL.Text
});
export const WithdrawArgs = IDL.Record({
  to: IDL.Principal,
  from_subaccount: IDL.Opt(IDL.Vec(IDL.Nat8)),
  created_at_time: IDL.Opt(IDL.Nat64),
  amount: IDL.Nat
});
export const WithdrawError = IDL.Variant({
  FailedToWithdraw: IDL.Record({
    rejection_code: RejectionCode,
    fee_block: IDL.Opt(IDL.Nat),
    rejection_reason: IDL.Text
  }),
  GenericError: IDL.Record({message: IDL.Text, error_code: IDL.Nat}),
  TemporarilyUnavailable: IDL.Null,
  Duplicate: IDL.Record({duplicate_of: IDL.Nat}),
  BadFee: IDL.Record({expected_fee: IDL.Nat}),
  InvalidReceiver: IDL.Record({receiver: IDL.Principal}),
  CreatedInFuture: IDL.Record({ledger_time: IDL.Nat64}),
  TooOld: IDL.Null,
  InsufficientFunds: IDL.Record({balance: IDL.Nat})
});
export const WithdrawFromArgs = IDL.Record({
  to: IDL.Principal,
  spender_subaccount: IDL.Opt(IDL.Vec(IDL.Nat8)),
  from: Account,
  created_at_time: IDL.Opt(IDL.Nat64),
  amount: IDL.Nat
});
export const WithdrawFromError = IDL.Variant({
  GenericError: IDL.Record({message: IDL.Text, error_code: IDL.Nat}),
  TemporarilyUnavailable: IDL.Null,
  InsufficientAllowance: IDL.Record({allowance: IDL.Nat}),
  Duplicate: IDL.Record({duplicate_of: BlockIndex}),
  InvalidReceiver: IDL.Record({receiver: IDL.Principal}),
  CreatedInFuture: IDL.Record({ledger_time: IDL.Nat64}),
  TooOld: IDL.Null,
  FailedToWithdrawFrom: IDL.Record({
    withdraw_from_block: IDL.Opt(IDL.Nat),
    rejection_code: RejectionCode,
    refund_block: IDL.Opt(IDL.Nat),
    approval_refund_block: IDL.Opt(IDL.Nat),
    rejection_reason: IDL.Text
  }),
  InsufficientFunds: IDL.Record({balance: IDL.Nat})
});

export const idlService = IDL.Service({
  create_canister: IDL.Func(
    [CreateCanisterArgs],
    [
      IDL.Variant({
        Ok: CreateCanisterSuccess,
        Err: CreateCanisterError
      })
    ],
    []
  ),
  create_canister_from: IDL.Func(
    [CreateCanisterFromArgs],
    [
      IDL.Variant({
        Ok: CreateCanisterSuccess,
        Err: CreateCanisterFromError
      })
    ],
    []
  ),
  deposit: IDL.Func([DepositArgs], [DepositResult], []),
  http_request: IDL.Func([HttpRequest], [HttpResponse], ['query']),
  icrc103_get_allowances: IDL.Func([GetAllowancesArgs], [ICRC103GetAllowancesResponse], ['query']),
  icrc106_get_index_principal: IDL.Func([], [GetIndexPrincipalResult], ['query']),
  icrc1_balance_of: IDL.Func([Account], [IDL.Nat], ['query']),
  icrc1_decimals: IDL.Func([], [IDL.Nat8], ['query']),
  icrc1_fee: IDL.Func([], [IDL.Nat], ['query']),
  icrc1_metadata: IDL.Func([], [IDL.Vec(IDL.Tuple(IDL.Text, MetadataValue))], ['query']),
  icrc1_minting_account: IDL.Func([], [IDL.Opt(Account)], ['query']),
  icrc1_name: IDL.Func([], [IDL.Text], ['query']),
  icrc1_supported_standards: IDL.Func([], [IDL.Vec(SupportedStandard)], ['query']),
  icrc1_symbol: IDL.Func([], [IDL.Text], ['query']),
  icrc1_total_supply: IDL.Func([], [IDL.Nat], ['query']),
  icrc1_transfer: IDL.Func([TransferArgs], [IDL.Variant({Ok: BlockIndex, Err: TransferError})], []),
  icrc2_allowance: IDL.Func([AllowanceArgs], [Allowance], ['query']),
  icrc2_approve: IDL.Func([ApproveArgs], [IDL.Variant({Ok: IDL.Nat, Err: ApproveError})], []),
  icrc2_transfer_from: IDL.Func(
    [TransferFromArgs],
    [IDL.Variant({Ok: IDL.Nat, Err: TransferFromError})],
    []
  ),
  icrc3_get_archives: IDL.Func([GetArchivesArgs], [GetArchivesResult], ['query']),
  icrc3_get_blocks: IDL.Func([GetBlocksArgs], [GetBlocksResult], ['query']),
  icrc3_get_tip_certificate: IDL.Func([], [IDL.Opt(DataCertificate)], ['query']),
  icrc3_supported_block_types: IDL.Func([], [IDL.Vec(SupportedBlockType)], ['query']),
  withdraw: IDL.Func([WithdrawArgs], [IDL.Variant({Ok: BlockIndex, Err: WithdrawError})], []),
  withdraw_from: IDL.Func(
    [WithdrawFromArgs],
    [IDL.Variant({Ok: BlockIndex, Err: WithdrawFromError})],
    []
  )
});

export const idlInitArgs = [LedgerArgs];

export const idlFactory = ({IDL}) => {
  const GetBlocksResult = IDL.Rec();
  const Value = IDL.Rec();
  const ChangeIndexId = IDL.Variant({
    SetTo: IDL.Principal,
    Unset: IDL.Null
  });
  const UpgradeArgs = IDL.Record({
    change_index_id: IDL.Opt(ChangeIndexId),
    max_blocks_per_request: IDL.Opt(IDL.Nat64)
  });
  const Account = IDL.Record({
    owner: IDL.Principal,
    subaccount: IDL.Opt(IDL.Vec(IDL.Nat8))
  });
  const InitArgs = IDL.Record({
    initial_balances: IDL.Opt(IDL.Vec(IDL.Tuple(Account, IDL.Nat))),
    index_id: IDL.Opt(IDL.Principal),
    max_blocks_per_request: IDL.Nat64
  });
  const LedgerArgs = IDL.Variant({
    Upgrade: IDL.Opt(UpgradeArgs),
    Init: InitArgs
  });
  const SubnetFilter = IDL.Record({subnet_type: IDL.Opt(IDL.Text)});
  const SubnetSelection = IDL.Variant({
    Filter: SubnetFilter,
    Subnet: IDL.Record({subnet: IDL.Principal})
  });
  const CanisterSettings = IDL.Record({
    freezing_threshold: IDL.Opt(IDL.Nat),
    controllers: IDL.Opt(IDL.Vec(IDL.Principal)),
    reserved_cycles_limit: IDL.Opt(IDL.Nat),
    memory_allocation: IDL.Opt(IDL.Nat),
    compute_allocation: IDL.Opt(IDL.Nat)
  });
  const CmcCreateCanisterArgs = IDL.Record({
    subnet_selection: IDL.Opt(SubnetSelection),
    settings: IDL.Opt(CanisterSettings)
  });
  const CreateCanisterArgs = IDL.Record({
    from_subaccount: IDL.Opt(IDL.Vec(IDL.Nat8)),
    created_at_time: IDL.Opt(IDL.Nat64),
    amount: IDL.Nat,
    creation_args: IDL.Opt(CmcCreateCanisterArgs)
  });
  const BlockIndex = IDL.Nat;
  const CreateCanisterSuccess = IDL.Record({
    block_id: BlockIndex,
    canister_id: IDL.Principal
  });
  const CreateCanisterError = IDL.Variant({
    GenericError: IDL.Record({
      message: IDL.Text,
      error_code: IDL.Nat
    }),
    TemporarilyUnavailable: IDL.Null,
    Duplicate: IDL.Record({
      duplicate_of: IDL.Nat,
      canister_id: IDL.Opt(IDL.Principal)
    }),
    CreatedInFuture: IDL.Record({ledger_time: IDL.Nat64}),
    FailedToCreate: IDL.Record({
      error: IDL.Text,
      refund_block: IDL.Opt(BlockIndex),
      fee_block: IDL.Opt(BlockIndex)
    }),
    TooOld: IDL.Null,
    InsufficientFunds: IDL.Record({balance: IDL.Nat})
  });
  const CreateCanisterFromArgs = IDL.Record({
    spender_subaccount: IDL.Opt(IDL.Vec(IDL.Nat8)),
    from: Account,
    created_at_time: IDL.Opt(IDL.Nat64),
    amount: IDL.Nat,
    creation_args: IDL.Opt(CmcCreateCanisterArgs)
  });
  const RejectionCode = IDL.Variant({
    NoError: IDL.Null,
    CanisterError: IDL.Null,
    SysTransient: IDL.Null,
    DestinationInvalid: IDL.Null,
    Unknown: IDL.Null,
    SysFatal: IDL.Null,
    CanisterReject: IDL.Null
  });
  const CreateCanisterFromError = IDL.Variant({
    FailedToCreateFrom: IDL.Record({
      create_from_block: IDL.Opt(BlockIndex),
      rejection_code: RejectionCode,
      refund_block: IDL.Opt(BlockIndex),
      approval_refund_block: IDL.Opt(BlockIndex),
      rejection_reason: IDL.Text
    }),
    GenericError: IDL.Record({
      message: IDL.Text,
      error_code: IDL.Nat
    }),
    TemporarilyUnavailable: IDL.Null,
    InsufficientAllowance: IDL.Record({allowance: IDL.Nat}),
    Duplicate: IDL.Record({
      duplicate_of: IDL.Nat,
      canister_id: IDL.Opt(IDL.Principal)
    }),
    CreatedInFuture: IDL.Record({ledger_time: IDL.Nat64}),
    TooOld: IDL.Null,
    InsufficientFunds: IDL.Record({balance: IDL.Nat})
  });
  const DepositArgs = IDL.Record({
    to: Account,
    memo: IDL.Opt(IDL.Vec(IDL.Nat8))
  });
  const DepositResult = IDL.Record({
    balance: IDL.Nat,
    block_index: BlockIndex
  });
  const HttpRequest = IDL.Record({
    url: IDL.Text,
    method: IDL.Text,
    body: IDL.Vec(IDL.Nat8),
    headers: IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text))
  });
  const HttpResponse = IDL.Record({
    body: IDL.Vec(IDL.Nat8),
    headers: IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    status_code: IDL.Nat16
  });
  const GetAllowancesArgs = IDL.Record({
    take: IDL.Opt(IDL.Nat),
    prev_spender: IDL.Opt(Account),
    from_account: IDL.Opt(Account)
  });
  const Allowances = IDL.Vec(
    IDL.Record({
      from_account: Account,
      to_spender: Account,
      allowance: IDL.Nat,
      expires_at: IDL.Opt(IDL.Nat64)
    })
  );
  const GetAllowancesError = IDL.Variant({
    GenericError: IDL.Record({
      message: IDL.Text,
      error_code: IDL.Nat
    }),
    AccessDenied: IDL.Record({reason: IDL.Text})
  });
  const ICRC103GetAllowancesResponse = IDL.Variant({
    Ok: Allowances,
    Err: GetAllowancesError
  });
  const GetIndexPrincipalError = IDL.Variant({
    GenericError: IDL.Record({
      description: IDL.Text,
      error_code: IDL.Nat
    }),
    IndexPrincipalNotSet: IDL.Null
  });
  const GetIndexPrincipalResult = IDL.Variant({
    Ok: IDL.Principal,
    Err: GetIndexPrincipalError
  });
  const MetadataValue = IDL.Variant({
    Int: IDL.Int,
    Nat: IDL.Nat,
    Blob: IDL.Vec(IDL.Nat8),
    Text: IDL.Text
  });
  const SupportedStandard = IDL.Record({url: IDL.Text, name: IDL.Text});
  const TransferArgs = IDL.Record({
    to: Account,
    fee: IDL.Opt(IDL.Nat),
    memo: IDL.Opt(IDL.Vec(IDL.Nat8)),
    from_subaccount: IDL.Opt(IDL.Vec(IDL.Nat8)),
    created_at_time: IDL.Opt(IDL.Nat64),
    amount: IDL.Nat
  });
  const TransferError = IDL.Variant({
    GenericError: IDL.Record({
      message: IDL.Text,
      error_code: IDL.Nat
    }),
    TemporarilyUnavailable: IDL.Null,
    BadBurn: IDL.Record({min_burn_amount: IDL.Nat}),
    Duplicate: IDL.Record({duplicate_of: IDL.Nat}),
    BadFee: IDL.Record({expected_fee: IDL.Nat}),
    CreatedInFuture: IDL.Record({ledger_time: IDL.Nat64}),
    TooOld: IDL.Null,
    InsufficientFunds: IDL.Record({balance: IDL.Nat})
  });
  const AllowanceArgs = IDL.Record({
    account: Account,
    spender: Account
  });
  const Allowance = IDL.Record({
    allowance: IDL.Nat,
    expires_at: IDL.Opt(IDL.Nat64)
  });
  const ApproveArgs = IDL.Record({
    fee: IDL.Opt(IDL.Nat),
    memo: IDL.Opt(IDL.Vec(IDL.Nat8)),
    from_subaccount: IDL.Opt(IDL.Vec(IDL.Nat8)),
    created_at_time: IDL.Opt(IDL.Nat64),
    amount: IDL.Nat,
    expected_allowance: IDL.Opt(IDL.Nat),
    expires_at: IDL.Opt(IDL.Nat64),
    spender: Account
  });
  const ApproveError = IDL.Variant({
    GenericError: IDL.Record({
      message: IDL.Text,
      error_code: IDL.Nat
    }),
    TemporarilyUnavailable: IDL.Null,
    Duplicate: IDL.Record({duplicate_of: IDL.Nat}),
    BadFee: IDL.Record({expected_fee: IDL.Nat}),
    AllowanceChanged: IDL.Record({current_allowance: IDL.Nat}),
    CreatedInFuture: IDL.Record({ledger_time: IDL.Nat64}),
    TooOld: IDL.Null,
    Expired: IDL.Record({ledger_time: IDL.Nat64}),
    InsufficientFunds: IDL.Record({balance: IDL.Nat})
  });
  const TransferFromArgs = IDL.Record({
    to: Account,
    fee: IDL.Opt(IDL.Nat),
    spender_subaccount: IDL.Opt(IDL.Vec(IDL.Nat8)),
    from: Account,
    memo: IDL.Opt(IDL.Vec(IDL.Nat8)),
    created_at_time: IDL.Opt(IDL.Nat64),
    amount: IDL.Nat
  });
  const TransferFromError = IDL.Variant({
    GenericError: IDL.Record({
      message: IDL.Text,
      error_code: IDL.Nat
    }),
    TemporarilyUnavailable: IDL.Null,
    InsufficientAllowance: IDL.Record({allowance: IDL.Nat}),
    BadBurn: IDL.Record({min_burn_amount: IDL.Nat}),
    Duplicate: IDL.Record({duplicate_of: IDL.Nat}),
    BadFee: IDL.Record({expected_fee: IDL.Nat}),
    CreatedInFuture: IDL.Record({ledger_time: IDL.Nat64}),
    TooOld: IDL.Null,
    InsufficientFunds: IDL.Record({balance: IDL.Nat})
  });
  const GetArchivesArgs = IDL.Record({from: IDL.Opt(IDL.Principal)});
  const GetArchivesResult = IDL.Vec(
    IDL.Record({
      end: IDL.Nat,
      canister_id: IDL.Principal,
      start: IDL.Nat
    })
  );
  const GetBlocksArgs = IDL.Vec(IDL.Record({start: IDL.Nat, length: IDL.Nat}));
  Value.fill(
    IDL.Variant({
      Int: IDL.Int,
      Map: IDL.Vec(IDL.Tuple(IDL.Text, Value)),
      Nat: IDL.Nat,
      Nat64: IDL.Nat64,
      Blob: IDL.Vec(IDL.Nat8),
      Text: IDL.Text,
      Array: IDL.Vec(Value)
    })
  );
  GetBlocksResult.fill(
    IDL.Record({
      log_length: IDL.Nat,
      blocks: IDL.Vec(IDL.Record({id: IDL.Nat, block: Value})),
      archived_blocks: IDL.Vec(
        IDL.Record({
          args: GetBlocksArgs,
          callback: IDL.Func([GetBlocksArgs], [GetBlocksResult], ['query'])
        })
      )
    })
  );
  const DataCertificate = IDL.Record({
    certificate: IDL.Vec(IDL.Nat8),
    hash_tree: IDL.Vec(IDL.Nat8)
  });
  const SupportedBlockType = IDL.Record({
    url: IDL.Text,
    block_type: IDL.Text
  });
  const WithdrawArgs = IDL.Record({
    to: IDL.Principal,
    from_subaccount: IDL.Opt(IDL.Vec(IDL.Nat8)),
    created_at_time: IDL.Opt(IDL.Nat64),
    amount: IDL.Nat
  });
  const WithdrawError = IDL.Variant({
    FailedToWithdraw: IDL.Record({
      rejection_code: RejectionCode,
      fee_block: IDL.Opt(IDL.Nat),
      rejection_reason: IDL.Text
    }),
    GenericError: IDL.Record({
      message: IDL.Text,
      error_code: IDL.Nat
    }),
    TemporarilyUnavailable: IDL.Null,
    Duplicate: IDL.Record({duplicate_of: IDL.Nat}),
    BadFee: IDL.Record({expected_fee: IDL.Nat}),
    InvalidReceiver: IDL.Record({receiver: IDL.Principal}),
    CreatedInFuture: IDL.Record({ledger_time: IDL.Nat64}),
    TooOld: IDL.Null,
    InsufficientFunds: IDL.Record({balance: IDL.Nat})
  });
  const WithdrawFromArgs = IDL.Record({
    to: IDL.Principal,
    spender_subaccount: IDL.Opt(IDL.Vec(IDL.Nat8)),
    from: Account,
    created_at_time: IDL.Opt(IDL.Nat64),
    amount: IDL.Nat
  });
  const WithdrawFromError = IDL.Variant({
    GenericError: IDL.Record({
      message: IDL.Text,
      error_code: IDL.Nat
    }),
    TemporarilyUnavailable: IDL.Null,
    InsufficientAllowance: IDL.Record({allowance: IDL.Nat}),
    Duplicate: IDL.Record({duplicate_of: BlockIndex}),
    InvalidReceiver: IDL.Record({receiver: IDL.Principal}),
    CreatedInFuture: IDL.Record({ledger_time: IDL.Nat64}),
    TooOld: IDL.Null,
    FailedToWithdrawFrom: IDL.Record({
      withdraw_from_block: IDL.Opt(IDL.Nat),
      rejection_code: RejectionCode,
      refund_block: IDL.Opt(IDL.Nat),
      approval_refund_block: IDL.Opt(IDL.Nat),
      rejection_reason: IDL.Text
    }),
    InsufficientFunds: IDL.Record({balance: IDL.Nat})
  });

  return IDL.Service({
    create_canister: IDL.Func(
      [CreateCanisterArgs],
      [
        IDL.Variant({
          Ok: CreateCanisterSuccess,
          Err: CreateCanisterError
        })
      ],
      []
    ),
    create_canister_from: IDL.Func(
      [CreateCanisterFromArgs],
      [
        IDL.Variant({
          Ok: CreateCanisterSuccess,
          Err: CreateCanisterFromError
        })
      ],
      []
    ),
    deposit: IDL.Func([DepositArgs], [DepositResult], []),
    http_request: IDL.Func([HttpRequest], [HttpResponse], ['query']),
    icrc103_get_allowances: IDL.Func(
      [GetAllowancesArgs],
      [ICRC103GetAllowancesResponse],
      ['query']
    ),
    icrc106_get_index_principal: IDL.Func([], [GetIndexPrincipalResult], ['query']),
    icrc1_balance_of: IDL.Func([Account], [IDL.Nat], ['query']),
    icrc1_decimals: IDL.Func([], [IDL.Nat8], ['query']),
    icrc1_fee: IDL.Func([], [IDL.Nat], ['query']),
    icrc1_metadata: IDL.Func([], [IDL.Vec(IDL.Tuple(IDL.Text, MetadataValue))], ['query']),
    icrc1_minting_account: IDL.Func([], [IDL.Opt(Account)], ['query']),
    icrc1_name: IDL.Func([], [IDL.Text], ['query']),
    icrc1_supported_standards: IDL.Func([], [IDL.Vec(SupportedStandard)], ['query']),
    icrc1_symbol: IDL.Func([], [IDL.Text], ['query']),
    icrc1_total_supply: IDL.Func([], [IDL.Nat], ['query']),
    icrc1_transfer: IDL.Func(
      [TransferArgs],
      [IDL.Variant({Ok: BlockIndex, Err: TransferError})],
      []
    ),
    icrc2_allowance: IDL.Func([AllowanceArgs], [Allowance], ['query']),
    icrc2_approve: IDL.Func([ApproveArgs], [IDL.Variant({Ok: IDL.Nat, Err: ApproveError})], []),
    icrc2_transfer_from: IDL.Func(
      [TransferFromArgs],
      [IDL.Variant({Ok: IDL.Nat, Err: TransferFromError})],
      []
    ),
    icrc3_get_archives: IDL.Func([GetArchivesArgs], [GetArchivesResult], ['query']),
    icrc3_get_blocks: IDL.Func([GetBlocksArgs], [GetBlocksResult], ['query']),
    icrc3_get_tip_certificate: IDL.Func([], [IDL.Opt(DataCertificate)], ['query']),
    icrc3_supported_block_types: IDL.Func([], [IDL.Vec(SupportedBlockType)], ['query']),
    withdraw: IDL.Func([WithdrawArgs], [IDL.Variant({Ok: BlockIndex, Err: WithdrawError})], []),
    withdraw_from: IDL.Func(
      [WithdrawFromArgs],
      [IDL.Variant({Ok: BlockIndex, Err: WithdrawFromError})],
      []
    )
  });
};

export const init = ({IDL}) => {
  const ChangeIndexId = IDL.Variant({
    SetTo: IDL.Principal,
    Unset: IDL.Null
  });
  const UpgradeArgs = IDL.Record({
    change_index_id: IDL.Opt(ChangeIndexId),
    max_blocks_per_request: IDL.Opt(IDL.Nat64)
  });
  const Account = IDL.Record({
    owner: IDL.Principal,
    subaccount: IDL.Opt(IDL.Vec(IDL.Nat8))
  });
  const InitArgs = IDL.Record({
    initial_balances: IDL.Opt(IDL.Vec(IDL.Tuple(Account, IDL.Nat))),
    index_id: IDL.Opt(IDL.Principal),
    max_blocks_per_request: IDL.Nat64
  });
  const LedgerArgs = IDL.Variant({
    Upgrade: IDL.Opt(UpgradeArgs),
    Init: InitArgs
  });

  return [LedgerArgs];
};
